export const validatorPositive = (value) => {
  if (value >= 0) {
    return true;
  }
  return false;
};

export const validatorPassword = (password) => {
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{6,}/;
  const validPassword = regExp.test(password);
  return validPassword;
};
export const validatorPasswordNormal = (password) => {
  const regExp = /(?=.*[a-zA-Z0-9])(?=.*[!@#$%&*()]).{4,}/;
  const validPassword = regExp.test(password);
  return validPassword;
};

export const validatorCreditCard = (creditnum) => {
  const cRegExp = /^(?:3[47][0-9]{13})$/;
  const validCreditCard = cRegExp.test(creditnum);
  return validCreditCard;
};

export const validatorUrlValidator = (val) => {
  if (val === undefined || val === null || val.length === 0) {
    return true;
  }
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9.-]+.[a-zA-Z]{2,5}[.]{0,1}/;
  return re.test(val);
};

export const validatorAlphaNumDot = (val) => {
  if (val === undefined || val === null || val.length === 0) {
    return true;
  }
  const re = /^[a-zA-Z0-9.]+$/;
  return re.test(val);
};

export const validatorAlphaNumDash = (val) => {
  if (val === undefined || val === null || val.length === 0) {
    return true;
  }
  const re = /^[a-zA-Z0-9_]+$/;
  return re.test(val);
};
export const validatorAlphaNumDotDash = (val) => {
  if (val === undefined || val === null || val.length === 0) {
    return true;
  }
  const re = /^[a-zA-Z0-9_.]+$/;
  return re.test(val);
};

export const validatorNumber = (val) => {
  const re = /^[0-9]+$/;
  return re.test(val);
};

export const validatorNumberMinOne = (val) => {
  const re = /^[0-9]+$/;
  return re.test(val) && val > 0;
};
export const validatorNumberMinZero = (val) => {
  const re = /^[0-9]+$/;
  return re.test(val) && val >= 0;
};
export const validatorTag = (val) => {
  if (val === undefined || val === null || val.length === 0) {
    return true;
  }
  const re = /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/;
  return !re.test(val);
};
